
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/radios/[...permalink]",
      function () {
        return require("private-next-pages/radios/[...permalink].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/radios/[...permalink]"])
      });
    }
  